/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useCurrentWorkspace, useDefaultWorkspace } from '@hooks/workspace';
import { useAuth } from '@hooks/useAuth';
import { NEW_ONBOARDING_RELEASE_DATE } from '@config/constants';

function HomePageRedirect() {
  const { user } = useAuth(true, 'internal');
  const { workspaceId: workspaceIdParam } = useParams();
  const defaultWorkspace = useDefaultWorkspace(false);
  const [currentWorkspace, setCurrentWorkspace] = useCurrentWorkspace(false);
  const workspaceId =
    workspaceIdParam ?? currentWorkspace?.id ?? defaultWorkspace?.id;
  useEffect(() => {
    if (workspaceId) setCurrentWorkspace(workspaceId);
  }, [workspaceId, setCurrentWorkspace]);

  if (!currentWorkspace) return null;

  const isContributor = currentWorkspace.role === 'workspace://contributor';
  const isShowOnboardingPage =
    !user.completedOnboardingSteps.length &&
    user?.createdAt &&
    new Date(user.createdAt).getTime() >= NEW_ONBOARDING_RELEASE_DATE.getTime();

  return (
    <Navigate
      // TODO: #86c63g6bw - hide Bootcamp(Onboarding page)
      // to={
      //   isContributor && isShowOnboardingPage
      //     ? `/start/${currentWorkspace.id}`
      //     : `/campaigns/all/${currentWorkspace.id}`
      // }
      to={`/campaigns/all/${currentWorkspace.id}`}
      replace
    />
  );
}

export default HomePageRedirect;
